import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";

export function Preloader({ onDone }: { onDone: () => void }) {
  const [count, setCount] = useState(0);
  const [exit, setExit] = useState(false);

  useEffect(() => {
    let current = 0;
    const step = () => {
      current += Math.floor(Math.random() * 8) + 3;
      if (current >= 100) {
        current = 100;
        setCount(100);
        setTimeout(() => setExit(true), 350);
        setTimeout(onDone, 1250);
        return;
      }
      setCount(current);
      setTimeout(step, 60 + Math.random() * 60);
    };
    const t = setTimeout(step, 120);
    return () => clearTimeout(t);
  }, [onDone]);

  const letters = "SNEHA".split("");

  return (
    <AnimatePresence>
      {!exit && (
        <motion.div
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#05060b]"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex overflow-hidden">
            {letters.map((l, i) => (
              <motion.span
                key={i}
                className="font-display text-6xl font-extrabold tracking-tight text-white md:text-8xl"
                initial={{ y: "110%", rotate: 8 }}
                animate={{ y: "0%", rotate: 0 }}
                transition={{
                  duration: 0.9,
                  delay: 0.1 + i * 0.07,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                {l}
              </motion.span>
            ))}
          </div>

          <motion.span
            className="mt-2 font-mono text-xs uppercase tracking-[0.5em] text-muted"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Sudhir
          </motion.span>

          <div className="mt-10 h-px w-52 overflow-hidden bg-white/10">
            <motion.div
              className="h-full origin-left bg-gradient-to-r from-primary to-accent"
              animate={{ width: `${count}%` }}
              transition={{ ease: "easeOut", duration: 0.4 }}
            />
          </div>

          <div className="mt-4 font-mono text-sm tabular-nums text-muted">
            {count}%
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
